import { useState, useEffect, useContext } from "react";
import { DadosConsultaPatrimonio } from "../../General/Format/patrimonio";
import { AnexosContext } from "../../../contexts/anexosProvider";
import LoadingSpinner from "../../Loader/load";
import PatrimonioModal from "./Modal";
import BaseInput from "../../General/FormsComp/Input/BaseInput";
import BaseSelect from "../../General/FormsComp/Select/BaseSelect";
import BaseButton from "../../General/FormsComp/Button/BaseButton";

const ConsultaTipo = ({ handleSearchClick, editedData, setEditedData, patrimonioModal, setPatrimonioModal, patrimonioType, loading }) => {
    const { anexosByClient } = useContext(AnexosContext);
    const [anexos, setAnexos] = useState([]);

    useEffect(() => {
        let idCliente = editedData?.id_cliente;
        if (idCliente) {
            anexosByClient(idCliente).then((anexos) => {
                setAnexos(anexos);
            });
        }
    }, [editedData?.id_cliente]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditedData({ ...editedData, [name]: value });
    };

    const handleCloseModal = () => {
        setPatrimonioModal(false);
    }

    const dados = DadosConsultaPatrimonio(editedData, anexos);

    return (
        <div className="space-y-4">
            {dados.map((dado, index) => (
                <div key={index} data-tour-id={`consulta:${dado.name}`}>
                    {dado.tipo === "Select" ? (
                        <BaseSelect
                            label={dado.titulo}
                            name={dado.name}
                            value={dado.valor}
                            onChange={handleInputChange}
                            options={dado.options || []}
                            placeholder="Selecione uma opção"
                            valueKey="id"
                            labelKey="nome"
                        />
                    ) : (
                        <BaseInput
                            label={dado.titulo}
                            name={dado.name}
                            value={dado.valor}
                            onChange={handleInputChange}
                            type="text"
                            placeholder={dado.titulo}
                        />
                    )}
                </div>
            ))}
            <div className="pt-4">
                {loading ? (
                    <LoadingSpinner />
                ) : (
                    <BaseButton
                        onClick={handleSearchClick}
                        variant="primary"
                        size="lg"
                        fullWidth
                        data-tour-id="consulta:consultar"
                    >
                        Consultar
                    </BaseButton>
                )}
            </div>
            {patrimonioModal && (
                <PatrimonioModal 
                    patrimonioModal={patrimonioModal} 
                    handleCloseModal={handleCloseModal} 
                    patrimonioType={patrimonioType} 
                />
            )}
        </div>
    );

};

export default ConsultaTipo;